import React from 'react'
import './WithEventWarning.css';
import classNames from 'classnames'

const WithEventWarning = (WrappedModal)  => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        warning: false
      }
    }
    enterCheck = (event) => {
      if(event.key === "Enter") {
        this.setState({
          warning:true
        })
      }
    };

    componentWillMount() {
      document.addEventListener("keydown", this.enterCheck, false);
    }
    componentWillUnmount() {
      document.removeEventListener("keydown", this.enterCheck, false);
    
    }
    render() {
      let classes = classNames({
        "WithEventWarning": this.state.warning
      })
      return (
        <WrappedModal className={classes} {...this.props}></WrappedModal>
      )
    }
  }
}
  

export default WithEventWarning